module.exports = __webpack_public_path__ + "img/goods16_3.8c45e94a.jpg";